const stateEnum = {
  COMPANY_LIST: 0,  //洽谈公司
  PLAYBACK: 1,  //回放
  SEEAPPOINTMENT: 2, //查看预约
  LINEHISTORY: 3, //查看排队历史
  OFFLINEAPPOINTMENTS: 4 //查看线下预约
}
export {
  stateEnum
}